import { useRef } from 'react';
import classnames from 'classnames';
import Button from 'components/Button/Button';
import ScootersStore from 'stores/Scooters';
import styles from './Rules.module.scss';
import { useEffect } from 'react';
import { useState } from 'react';

const SLIDES = [
  // { 
  //   title: `I confirm that I am${'\n'} at least 17 years or older${'\n'} to ride `, 
  //   bg: 'screen1', 
  // },
  // { 
  //   title: `Do not ride on sidewalks${'\n'} or you will get fined`, 
  //   bg: 'screen2',  
  // },
  { 
    title: `Park only in${'\n'} Go X locations`, 
    bg: 'screen3', 
  },
  // { 
  //   title: `Keep out of restricted${'\n'} riding zones or face${'\n'} a $60 penalty`, 
  //   bg: 'screen4', 
  // },
  // { 
  //   title: `Kick to start riding${'\n'} a scooter`, 
  //   bg: 'screen5', 
  // }
];

const SLIDES_HONOLULU = [...SLIDES];
SLIDES_HONOLULU.splice(3, 0, {
  title: `Do not park scooters${'\n'} at Biki stations`, 
  bg: 'screenHonolulu', 
});

export default function Rules({ visible = false, onComplete }) {
  const scroll = useRef(null);
  const [ slides, setSlides ] = useState(null);

  useEffect(() => {
    if (visible) {
      setSlides(ScootersStore.selected?.isHonolulu() ? SLIDES_HONOLULU : SLIDES);
    }
  }, [visible]);

  function next() {
    if (scroll?.current.scrollWidth <= scroll?.current.scrollLeft + window.innerWidth) {
      window.localStorage?.setItem('tutorial_viewved', 1);
      onComplete();
    }

    scroll?.current.scrollTo(({
      top: 0,
      left: window.innerWidth + scroll?.current.scrollLeft,
      behavior: 'smooth'
    }));
  }

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.slides} ref={scroll}>
        {slides?.map(slide =>
          <div className={classnames(styles.slide, styles[slide.bg])} key={slide.bg}>
            <div className={styles.title}>
              {slide.title}
            </div>
          </div>
        )}
      </div>
      <div className={styles.overlay}>
        <Button className={styles.button} onClick={next}>
          Next
        </Button>
      </div>
      
    </div>
  )
}